import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { organizationClient } from '../client';

export let notificationsLoader = createLoader({
  name: 'notifications',
  fetch: (i: { organizationId: string }) =>
    withAuth(() => organizationClient.notification.list(i)),
  mutators: {
    archive: (i: { notificationId: string }, { input: { organizationId } }) =>
      withAuth(() =>
        organizationClient.notification.archive({
          organizationId,
          ...i
        })
      ),

    unarchive: (i: { notificationId: string }, { input: { organizationId } }) =>
      withAuth(() =>
        organizationClient.notification.unarchive({
          organizationId,
          ...i
        })
      ),

    markRead: (i: { notificationIds: string[] }, { input: { organizationId } }) =>
      withAuth(() =>
        organizationClient.notification.markRead({
          organizationId,
          ...i
        })
      )
  }
});

export let useNotifications = (organizationId: string | null | undefined) => {
  let notifications = notificationsLoader.use(organizationId ? { organizationId } : null);

  return {
    ...notifications,
    archiveMutator: notifications.useMutator('archive'),
    markReadMutator: notifications.useMutator('markRead'),
    unarchiveMutator: notifications.useMutator('unarchive')
  };
};
